<template>
  <div class="addEdit-block">
    <el-form
        class="add-update-preview"
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="180px"
    >
      <template >
        <el-form-item class="input" v-if="type!='info'"  label="作品名称" prop="mingcheng" >
          <el-input v-model="ruleForm.mingcheng" placeholder="作品名称" clearable  :readonly="ro.mingcheng"></el-input>
        </el-form-item>
        <el-form-item v-else class="input" label="作品名称" prop="mingcheng" >
          <el-input v-model="ruleForm.mingcheng" placeholder="作品名称" readonly></el-input>
        </el-form-item>
        <el-form-item class="select" v-if="type!='info'"  label="作品分类" prop="category" >
          <el-select :disabled="ro.category" v-model="ruleForm.category" placeholder="请选择作品分类"  filterable>
            <el-option
                v-for="(item,index) in categoryOptions"
                v-bind:key="index"
                :label="item.category"
                :value="item.category">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-else class="input" label="作品分类" prop="category" >
          <el-input v-model="ruleForm.category"
                    placeholder="作品分类" readonly></el-input>
        </el-form-item>
        <el-form-item class="upload" v-if="type!='info' && !ro.fengmian" label="作品封面" prop="fengmian" >
          <file-upload
              tip="点击上传作品封面"
              action="file/upload"
              :limit="3"
              :disabled="ro.fengmian"
              :multiple="true"
              :fileUrls="ruleForm.fengmian?ruleForm.fengmian:''"
              @change="fengmianUploadChange"
          ></file-upload>
        </el-form-item>
        <el-form-item class="upload" v-else-if="ruleForm.fengmian" label="作品封面" prop="fengmian" >
          <img v-if="ruleForm.fengmian.substring(0,4)=='http'&&ruleForm.fengmian.split(',w').length>1" class="upload-img" style="margin-right:20px;" v-bind:key="index" :src="ruleForm.fengmian" width="100" height="100" @click="imgPreView(ruleForm.tupian)">
          <img v-else-if="ruleForm.fengmian.substring(0,4)=='http'" class="upload-img" style="margin-right:20px;" v-bind:key="index" :src="ruleForm.fengmian.split(',')[0]" width="100" height="100" @click="imgPreView(ruleForm.tupian.split(',')[0])">
          <img v-else class="upload-img" style="margin-right:20px;" v-bind:key="index" v-for="(item,index) in ruleForm.fengmian.split(',')" :src="$base.url+item" width="100" height="100" @click="imgPreView($base.url+item)">
        </el-form-item>

        <el-form-item class="input" v-if="type!='info'"  label="拍摄地点" prop="didian" >
          <el-input v-model="ruleForm.didian" placeholder="拍摄地点" clearable  :readonly="ro.didian"></el-input>
        </el-form-item>
        <el-form-item v-else class="input" label="拍摄地点" prop="didian" >
          <el-input v-model="ruleForm.didian" placeholder="拍摄地点" readonly></el-input>
        </el-form-item>

        <el-form-item class="input" v-if="type!='info'"  label="拍摄时间" prop="shijian" >
          <el-input v-model="ruleForm.shijian" placeholder="拍摄时间" clearable  :readonly="ro.shijian"></el-input>
        </el-form-item>
        <el-form-item v-else class="input" label="拍摄时间" prop="shijian" >
          <el-input v-model="ruleForm.shijian" placeholder="拍摄时间" readonly></el-input>
        </el-form-item>


<!--        <el-form-item class="input" v-if="type!='info'"  label="摄影师手机号" prop="sheyingshizhanghao" >-->
<!--          <el-input v-model="ruleForm.sheyingshizhanghao" placeholder="摄影师手机号" clearable  :readonly="ro.sheyingshizhanghao"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item v-else class="input" label="摄影师手机号" prop="sheyingshizhanghao" >-->
<!--          <el-input v-model="ruleForm.sheyingshizhanghao" placeholder="摄影师手机号" readonly></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item class="input" v-if="type!='info'"  label="摄影师姓名" prop="sheyingshimingcheng" >-->
<!--          <el-input v-model="ruleForm.sheyingshimingcheng" placeholder="摄影师姓名" clearable  :readonly="ro.sheyingshimingcheng"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item v-else class="input" label="摄影师姓名" prop="sheyingshimingcheng" >-->
<!--          <el-input v-model="ruleForm.sheyingshimingcheng" placeholder="摄影师姓名" readonly></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item class="input" v-if="type!='info'"  label="摄影师住址" prop="sheyingshidizhi" >-->
<!--          <el-input v-model="ruleForm.sheyingshidizhi" placeholder="摄影师住址" clearable  :readonly="ro.sheyingshidizhi"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item v-else class="input" label="摄影师住址" prop="sheyingshidizhi" >-->
<!--          <el-input v-model="ruleForm.sheyingshidizhi" placeholder="摄影师住址" readonly></el-input>-->
<!--        </el-form-item>-->

      </template>

      <el-form-item v-if="type!='info'" class="editorBox" label="作品详情" prop="xiangqing" >
        <editor
            style="min-width: 200px; max-width: 600px;"
            v-model="ruleForm.xiangqing"
            class="editor"
            myQuillEditor="xiangqing"
            action="file/upload">
        </editor>
      </el-form-item>
      <el-form-item v-else-if="ruleForm.xiangqing" label="作品详情" prop="xiangqing"  class="textBox">
        <span class="text ql-snow ql-editor" v-html="ruleForm.xiangqing"></span>
      </el-form-item>
      <el-form-item class="btn">
        <el-button class="btn3"  v-if="type!='info'" type="success" @click="onSubmit">
          <span class="icon iconfont icon-queren15"></span>
          保存信息
        </el-button>
        <el-button class="btn4" v-if="type!='info'" type="success" @click="back()">
          <span class="icon iconfont icon-guanbi2"></span>
          取消
        </el-button>
        <el-button class="btn5" v-if="type=='info'" type="success" @click="back()">
          <span class="icon iconfont icon-fanhui13"></span>
          返回
        </el-button>
      </el-form-item>
    </el-form>


  </div>
</template>
<script>
import {
  isNumber,
  isIntNumer,
} from "@/utils/validate";
export default {
  data() {
    var validateNumber = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isNumber(value)) {
        callback(new Error("请输入数字"));
      } else {
        callback();
      }
    };
    var validateIntNumber = (rule, value, callback) => {
      if(!value){
        callback();
      } else if (!isIntNumer(value)) {
        callback(new Error("请输入整数"));
      } else {
        callback();
      }
    };
    return {
      id: '',
      type: '',


      ro:{
        mingcheng : false,
        category : false,
        fengmian : false,
        zhizuogongyi : false,
        chandi : false,
        didian : false,
        dengji : false,
        caizhaishijian : false,
        shijian : false,
        chongpaofangfa : false,
        sheyingshizhanghao : false,
        sheyingshimingcheng : false,
        sheyingshidizhi : false,
        xiangqing : false,
        onelimittimes : false,
        alllimittimes : false,
        price : false,
        thumbsupnum : false,
        crazilynum : false,
        clicktime : false,
        clicknum : false,
        discussnum : false,
        totalscore : false,
        onshelves : false,
        storeupnum : false,
      },

      ruleForm: {
        mingcheng: '',
        category: '',
        fengmian: '',
        zhizuogongyi: '',
        chandi: '',
        didian: '',
        dengji: '',
        caizhaishijian: '',
        shijian: '',
        chongpaofangfa: '',
        sheyingshizhanghao: '',
        sheyingshimingcheng: '',
        sheyingshidizhi: '',
        xiangqing: '',
        clicktime: '',
        onshelves: 1,
      },
      categoryOptions: [],
      dengjiOptions: [],

      rules: {
        mingcheng: [
        ],
        category: [
        ],
        fengmian: [
        ],
        zhizuogongyi: [
        ],
        chandi: [
        ],
        didian: [
        ],
        dengji: [
        ],
        caizhaishijian: [
        ],
        shijian: [
        ],
        chongpaofangfa: [
        ],
        sheyingshizhanghao: [
        ],
        sheyingshimingcheng: [
        ],
        sheyingshidizhi: [
        ],
        xiangqing: [
        ],
        onelimittimes: [
          { validator: validateIntNumber, trigger: 'blur' },
        ],
        alllimittimes: [
          { validator: validateIntNumber, trigger: 'blur' },
        ],
        price: [
          { required: true, message: '价格不能为空', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' },
        ],
        thumbsupnum: [
          { validator: validateIntNumber, trigger: 'blur' },
        ],
        crazilynum: [
          { validator: validateIntNumber, trigger: 'blur' },
        ],
        clicktime: [
        ],
        clicknum: [
          { validator: validateIntNumber, trigger: 'blur' },
        ],
        discussnum: [
          { validator: validateIntNumber, trigger: 'blur' },
        ],
        totalscore: [
          { validator: validateNumber, trigger: 'blur' },
        ],
        onshelves: [
          { validator: validateIntNumber, trigger: 'blur' },
        ],
        storeupnum: [
          { validator: validateIntNumber, trigger: 'blur' },
        ],
      },
    };
  },
  props: ["parent"],
  computed: {
    sessionForm() {
      return JSON.parse(this.$storage.getObj('userForm'))
    },
    sessionTable() {
      return this.$storage.get('sessionTable')
    },



  },
  components: {
  },
  created() {
  },
  methods: {
    imgPreView(url){
      this.$parent.imgPreView(url)
    },
    // 下载
    download(file){
      window.open(`${file}`)
    },
    // 初始化
    init(id,type ) {
      if (id) {
        this.id = id;
        this.type = type;
      }
      if(this.type=='info'||this.type=='else'||this.type=='msg'){
        this.info(id);
      }else if(this.type=='xiangqing'){
        for(let x in this.ro) {
          this.ro[x] = true
        }
        this.xiangqing=false;
        this.info(id);
      }else if(this.type=='cross'){
        var obj = this.$storage.getObj('crossObj');
        for (var o in obj){
          if(o=='mingcheng'){
            this.ruleForm.mingcheng = obj[o];
            this.ro.mingcheng = true;
            continue;
          }
          if(o=='category'){
            this.ruleForm.category = obj[o];
            this.ro.category = true;
            continue;
          }
          if(o=='fengmian'){
            this.ruleForm.fengmian = obj[o];
            this.ro.fengmian = true;
            continue;
          }
          if(o=='zhizuogongyi'){
            this.ruleForm.zhizuogongyi = obj[o];
            this.ro.zhizuogongyi = true;
            continue;
          }
          if(o=='chandi'){
            this.ruleForm.chandi = obj[o];
            this.ro.chandi = true;
            continue;
          }
          if(o=='didian'){
            this.ruleForm.didian = obj[o];
            this.ro.didian = true;
            continue;
          }
          if(o=='dengji'){
            this.ruleForm.dengji = obj[o];
            this.ro.dengji = true;
            continue;
          }
          if(o=='caizhaishijian'){
            this.ruleForm.caizhaishijian = obj[o];
            this.ro.caizhaishijian = true;
            continue;
          }
          if(o=='shijian'){
            this.ruleForm.shijian = obj[o];
            this.ro.shijian = true;
            continue;
          }
          if(o=='chongpaofangfa'){
            this.ruleForm.chongpaofangfa = obj[o];
            this.ro.chongpaofangfa = true;
            continue;
          }
          if(o=='sheyingshizhanghao'){
            this.ruleForm.sheyingshizhanghao = obj[o];
            this.ro.sheyingshizhanghao = true;
            continue;
          }
          if(o=='sheyingshimingcheng'){
            this.ruleForm.sheyingshimingcheng = obj[o];
            this.ro.sheyingshimingcheng = true;
            continue;
          }
          if(o=='sheyingshidizhi'){
            this.ruleForm.sheyingshidizhi = obj[o];
            this.ro.sheyingshidizhi = true;
            continue;
          }
          if(o=='xiangqing'){
            this.ruleForm.xiangqing = obj[o];
            this.ro.xiangqing = true;
            continue;
          }
          if(o=='onelimittimes'){
            this.ruleForm.onelimittimes = obj[o];
            this.ro.onelimittimes = true;
            continue;
          }
          if(o=='alllimittimes'){
            this.ruleForm.alllimittimes = obj[o];
            this.ro.alllimittimes = true;
            continue;
          }
          if(o=='price'){
            this.ruleForm.price = obj[o];
            this.ro.price = true;
            continue;
          }
          if(o=='thumbsupnum'){
            this.ruleForm.thumbsupnum = obj[o];
            this.ro.thumbsupnum = true;
            continue;
          }
          if(o=='crazilynum'){
            this.ruleForm.crazilynum = obj[o];
            this.ro.crazilynum = true;
            continue;
          }
          if(o=='clicktime'){
            this.ruleForm.clicktime = obj[o];
            this.ro.clicktime = true;
            continue;
          }
          if(o=='clicknum'){
            this.ruleForm.clicknum = obj[o];
            this.ro.clicknum = true;
            continue;
          }
          if(o=='discussnum'){
            this.ruleForm.discussnum = obj[o];
            this.ro.discussnum = true;
            continue;
          }
          if(o=='totalscore'){
            this.ruleForm.totalscore = obj[o];
            this.ro.totalscore = true;
            continue;
          }
          if(o=='onshelves'){
            this.ruleForm.onshelves = obj[o];
            this.ro.onshelves = true;
            continue;
          }
          if(o=='storeupnum'){
            this.ruleForm.storeupnum = obj[o];
            this.ro.storeupnum = true;
            continue;
          }
        }
      }
      // 获取用户信息
      this.$http({
        url: `${this.sessionTable}/session`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
          var json = data.data;
          if(((json.sheyingshizhanghao!=''&&json.sheyingshizhanghao) || json.sheyingshizhanghao==0) && this.sessionTable!="users"){
            this.ruleForm.sheyingshizhanghao = json.sheyingshizhanghao
            this.ro.sheyingshizhanghao = true;
          }
          if(((json.sheyingshimingcheng!=''&&json.sheyingshimingcheng) || json.sheyingshimingcheng==0) && this.sessionTable!="users"){
            this.ruleForm.sheyingshimingcheng = json.sheyingshimingcheng
            this.ro.sheyingshimingcheng = true;
          }
          if(((json.sheyingshidizhi!=''&&json.sheyingshidizhi) || json.sheyingshidizhi==0) && this.sessionTable!="users"){
            this.ruleForm.sheyingshidizhi = json.sheyingshidizhi
            this.ro.sheyingshidizhi = true;
          }
        } else {
          this.$message.error(data.msg);
        }
      });
      this.$http({
        url: `category/lists`,
        method: "get",
        params:{type:1}
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.categoryOptions = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
      this.dengjiOptions = "特级,一级,二级".split(',')

    },
    // 多级联动参数

    async info(id) {
      await this.$http({
        url: `photographs/info/${id}`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.ruleForm = data.data;
          //解决前台上传图片后台不显示的问题
          let reg=new RegExp('../../../upload','g')//g代表全部
          this.ruleForm.xiangqing = this.ruleForm.xiangqing.replace(reg,'../../../photosystem/upload');
        } else {
          this.$message.error(data.msg);
        }
      });
    },

    // 提交
    async onSubmit() {
      if(this.ruleForm.fengmian!=null) {
        this.ruleForm.fengmian = this.ruleForm.fengmian.replace(new RegExp(this.$base.url,"g"),"");
      }
      if(this.ruleForm.price<0){
        this.$message.error("价格不能输入负数");
        return
      }
      if(this.ruleForm.alllimittimes<0){
        this.$message.error("库存不能输入负数");
        return
      }
      if(this.ruleForm.onelimittimes<0){
        this.$message.error("单次购买不能输入负数");
        return
      }
      var objcross = this.$storage.getObj('crossObj');
      if(!this.ruleForm.id) {
        delete this.ruleForm.userid
      }
      await this.$refs["ruleForm"].validate(async valid => {
        if (valid) {
          if(this.type=='cross'){
            var statusColumnName = this.$storage.get('statusColumnName');
            var statusColumnValue = this.$storage.get('statusColumnValue');
            if(statusColumnName!='') {
              var obj = this.$storage.getObj('crossObj');
              if(statusColumnName && !statusColumnName.startsWith("[")) {
                for (var o in obj){
                  if(o==statusColumnName){
                    obj[o] = statusColumnValue;
                  }
                }
                var table = this.$storage.get('crossTable');
                await this.$http({
                  url: `${table}/update`,
                  method: "post",
                  data: obj
                }).then(({ data }) => {});
              }
            }
          }
          await this.$http({
            url: `photographs/${!this.ruleForm.id ? "save" : "update"}`,
            method: "post",
            data: this.ruleForm
          }).then(async ({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  this.parent.showFlag = true;
                  this.parent.addOrUpdateFlag = false;
                  this.parent.photographsCrossAddOrUpdateFlag = false;
                  this.parent.search();
                }
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    // 获取uuid
    getUUID () {
      return new Date().getTime();
    },
    // 返回
    back() {
      this.parent.showFlag = true;
      this.parent.addOrUpdateFlag = false;
      this.parent.photographsCrossAddOrUpdateFlag = false;
    },
    fengmianUploadChange(fileUrls) {
      this.ruleForm.fengmian = fileUrls;
    },
  }
};
</script>
<style lang="scss" scoped>
.addEdit-block {
  padding: 30px;
}
.add-update-preview {
  border-radius: 10px;
  padding: 50px 20% 50px 10%;
  box-shadow: none;
  background: #fff8f0;
  display: flex;
  border-color: #ff9164;
  border-width: 4px 0 0 0;
  border-style: solid;
  flex-wrap: wrap;
}
.amap-wrapper {
  width: 100%;
  height: 500px;
}

.search-box {
  position: absolute;
}

.el-date-editor.el-input {
  width: auto;
}
.add-update-preview /deep/ .el-form-item {
  margin: 0 0 20px 0;
  width: 100%;
}
.add-update-preview .el-form-item /deep/ .el-form-item__label {
  padding: 0 10px 0 0;
  color: #666;
  white-space: nowrap;
  font-weight: 500;
  width: 180px;
  font-size: 16px;
  line-height: 40px;
  text-align: right;
}

.add-update-preview .el-form-item /deep/ .el-form-item__content {
  margin: 0 0 0 80px;
  display: flex;
  align-items: center;
}
.add-update-preview /deep/ .el-form-item.editorBox {
  margin: 0 0 20px 0;
  width: 100%;
}
.add-update-preview .el-form-item.editorBox /deep/ .el-form-item__label {
  padding: 0 10px 0 0;
  color: #666;
  font-weight: 500;
  width: 180px;
  font-size: 14px;
  line-height: 40px;
  text-align: right;
}

.add-update-preview .el-form-item.editorBox /deep/ .el-form-item__content {
  margin: 0;
  display: flex;
  align-items: center;
}
.add-update-preview /deep/.el-form-item.editorBox .editor {
  box-shadow: none;
  max-width: 100% !important;
  width: 100%;
  height: auto;
}
.add-update-preview /deep/.el-form-item.editorBox .editor .ql-toolbar {
  border: 1px solid #e7e8fc;
  background: #fff;
  border-width: 1px 1px 0;
}
.add-update-preview /deep/.el-form-item.editorBox .editor .ql-container {
  border: 1px solid #e7e8fc;
  background: #fff;
  min-height: 200px;
}
.add-update-preview /deep/.el-form-item.editorBox .editor .ql-container .ql-blank::before {
  color: #000;
}

.add-update-preview /deep/ .el-form-item.textBox {
  margin: 0 0 20px 0;
}
.add-update-preview .el-form-item.textBox /deep/ .el-form-item__label {
  padding: 0 10px 0 0;
  color: #666;
  white-space: nowrap;
  font-weight: 500;
  width: 180px;
  font-size: 14px;
  line-height: 40px;
  text-align: right;
}

.add-update-preview .el-form-item.textBox /deep/ .el-form-item__content {
  margin: 0 0 0 80px;
  display: flex;
  align-items: center;
}
.add-update-preview /deep/.el-form-item.textBox span.text {
  padding: 0;
  color: #666;
  font-weight: 500;
  display: inline-block;
  font-size: 16px;
  line-height: 40px;
}

.add-update-preview .el-input {
  width: 100%;
}
.add-update-preview .el-input /deep/ .el-input__inner {
  border: 1px solid #e7e8fc;
  border-radius: 4px;
  padding: 0 12px;
  box-shadow: none;
  outline: none;
  color: #333;
  width: 100%;
  font-size: 16px;
  height: 40px;
}
.add-update-preview .el-input /deep/ .el-input__inner[readonly="readonly"] {
  border: 0px solid #ddd;
  cursor: not-allowed;
  border-radius: 4px;
  padding: 0 12px;
  box-shadow: none;
  outline: none;
  color: #999;
  background: none;
  width: 100%;
  font-size: 16px;
  height: 40px;
}
.add-update-preview .el-input-number {
  text-align: left;
  width: 100%;
}
.add-update-preview .el-input-number /deep/ .el-input__inner {
  text-align: left;
  border: 1px solid #e7e8fc;
  border-radius: 4px;
  padding: 0 12px;
  box-shadow: none;
  outline: none;
  color: #333;
  width: 100%;
  font-size: 16px;
  height: 40px;
}
.add-update-preview .el-input-number /deep/ .is-disabled .el-input__inner {
  text-align: left;
  border: 0px solid #ddd;
  cursor: not-allowed;
  border-radius: 4px;
  padding: 0 12px;
  box-shadow: none;
  outline: none;
  color: #999;
  background: none;
  width: 100%;
  font-size: 16px;
  height: 40px;
}
.add-update-preview .el-input-number /deep/ .el-input-number__decrease {
  display: none;
}
.add-update-preview .el-input-number /deep/ .el-input-number__increase {
  display: none;
}
.add-update-preview .el-select {
  width: 100%;
}
.add-update-preview .el-select /deep/ .el-input__inner {
  border: 1px solid #e7e8fc;
  border-radius: 4px;
  padding: 0 10px;
  box-shadow: none;
  outline: none;
  color: #333;
  width: 100%;
  font-size: 16px;
  height: 40px;
}
.add-update-preview .el-select /deep/ .is-disabled .el-input__inner {
  border: 0;
  cursor: not-allowed;
  border-radius: 4px;
  padding: 0 10px;
  box-shadow: none;
  outline: none;
  color: #999;
  background: none;
  width: 100%;
  font-size: 16px;
  height: 40px;
}
.add-update-preview .el-date-editor {
  width: 100%;
}
.add-update-preview .el-date-editor /deep/ .el-input__inner {
  border: 1px solid #e7e8fc;
  border-radius: 4px;
  padding: 0 10px 0 30px;
  box-shadow: none;
  outline: none;
  color: #333;
  width: 100%;
  font-size: 16px;
  height: 40px;
}
.add-update-preview .el-date-editor /deep/ .el-input__inner[readonly="readonly"] {
  border: 0;
  cursor: not-allowed;
  border-radius: 4px;
  padding: 0 10px 0 30px;
  box-shadow: none;
  outline: none;
  color: #999;
  background: none;
  width: 100%;
  font-size: 16px;
  height: 40px;
}
.add-update-preview .viewBtn {
  border: 1px solid #eee;
  cursor: pointer;
  border-radius: 4px;
  padding: 0 15px;
  margin: 0 20px 0 0;
  outline: none;
  color: #ff7f00;
  background: #fff;
  width: auto;
  font-size: 14px;
  line-height: 40px;
  height: 40px;
  .iconfont {
    margin: 0 2px;
    color: #fff;
    display: none;
    font-size: 14px;
    height: 40px;
  }
}
.add-update-preview .viewBtn:hover {
  opacity: 0.8;
}
.add-update-preview .downBtn {
  border: 1px solid #eee;
  cursor: pointer;
  border-radius: 4px;
  padding: 0 15px;
  margin: 0 20px 0 0;
  outline: none;
  color: #ff7f00;
  background: #fff;
  width: auto;
  font-size: 14px;
  line-height: 40px;
  height: 40px;
  .iconfont {
    margin: 0 2px;
    color: #fff;
    display: none;
    font-size: 14px;
    height: 40px;
  }
}
.add-update-preview .downBtn:hover {
  opacity: 0.8;
}
.add-update-preview .unBtn {
  border: 1px solid #ddd;
  cursor: pointer;
  border-radius: 4px;
  padding: 0 15px;
  margin: 0 20px 0 0;
  outline: none;
  color: #999;
  background: #f6f6f6;
  width: auto;
  font-size: 14px;
  line-height: 40px;
  height: 40px;
  .iconfont {
    margin: 0 2px;
    color: #fff;
    display: none;
    font-size: 14px;
    height: 40px;
  }
}
.add-update-preview .unBtn:hover {
  opacity: 0.8;
}
.add-update-preview /deep/ .el-upload--picture-card {
  background: transparent;
  border: 0;
  border-radius: 0;
  width: auto;
  height: auto;
  line-height: initial;
  vertical-align: middle;
}

.add-update-preview /deep/ .upload .upload-img {
  border: 1px solid #e7e8fc;
  cursor: pointer;
  border-radius: 6px;
  color: #999;
  background: #fff;
  width: 80px;
  font-size: 26px;
  line-height: 80px;
  text-align: center;
  height: 80px;
}

.add-update-preview /deep/ .el-upload-list .el-upload-list__item {
  border: 1px solid #e7e8fc;
  cursor: pointer;
  border-radius: 6px;
  color: #999;
  background: #fff;
  width: 80px;
  font-size: 26px;
  line-height: 80px;
  text-align: center;
  height: 80px;
}

.add-update-preview /deep/ .el-upload .el-icon-plus {
  border: 1px solid #e7e8fc;
  cursor: pointer;
  border-radius: 6px;
  color: #999;
  background: #fff;
  width: 80px;
  font-size: 26px;
  line-height: 80px;
  text-align: center;
  height: 80px;
}
.add-update-preview /deep/ .el-upload__tip {
  color: #838fa1;
}
.add-update-preview /deep/ .el-form-item.fileupload {
  margin: 0 0 20px 0;
}
.add-update-preview .el-form-item.fileupload /deep/ .el-form-item__label {
  padding: 0 10px 0 0;
  color: #666;
  white-space: nowrap;
  font-weight: 500;
  width: 180px;
  font-size: 16px;
  line-height: 40px;
  text-align: right;
}

.add-update-preview .el-form-item.fileupload /deep/ .el-form-item__content {
  margin: 0 0 0 80px;
  display: flex;
  align-items: center;
}
.add-update-preview .el-form-item.fileupload /deep/ .el-upload-dragger {
  border: 1px solid #eee;
  cursor: pointer;
  background-color: #fff;
  border-radius: 6px;
  padding: 5px 20px 20px;
  overflow: hidden;
  width: auto;
  box-sizing: border-box;
  text-align: center;
  height: auto;
}
.add-update-preview .el-form-item.fileupload .el-upload-dragger /deep/ .el-icon-upload {
  margin: 0;
  color: #ff7f00;
  font-size: 60px;
  line-height: 1;
}
.add-update-preview .el-form-item.fileupload .el-upload-dragger /deep/ .el-upload__text {
  color: #606266;
  textalign: center;
  fontsize: 14px;
  line-height: 1;
}
.add-update-preview .el-form-item.fileupload .el-upload-dragger /deep/ .el-upload__text em {
  fontstyle: normal;
  color: #ff7f00;
}

.add-update-preview .el-textarea /deep/ .el-textarea__inner {
  border: 1px solid #e7e8fc;
  border-radius: 4px;
  padding: 12px;
  box-shadow: none;
  outline: none;
  color: #666;
  width: 100%;
  font-size: 16px;
  height: auto;
}
.add-update-preview .el-textarea /deep/ .el-textarea__inner[readonly="readonly"] {
  border: 0;
  cursor: not-allowed;
  border-radius: 4px;
  padding: 12px;
  box-shadow: none;
  outline: none;
  color: #666;
  background: none;
  width: 100%;
  font-size: 16px;
  height: auto;
}
.add-update-preview /deep/ .el-form-item.btn {
  padding: 0;
  margin: 10px auto 0;
  display: flex;
  width: 100%;
  justify-content: center;
  .btn1 {
    border: 0;
    cursor: pointer;
    border-radius: 4px;
    padding: 0 24px;
    margin: 0 20px 0 0;
    outline: none;
    color: #fff;
    background: rgba(255, 128, 0, 1);
    width: auto;
    font-size: 16px;
    min-width: 110px;
    height: 40px;
    .iconfont {
      margin: 0 2px;
      color: #fff;
      display: none;
      font-size: 16px;
      height: 40px;
    }
  }
  .btn1:hover {
    opacity: 0.8;
  }
  .btn2 {
    border: 0;
    cursor: pointer;
    border-radius: 4px;
    padding: 0 24px;
    margin: 0 20px 0 0;
    outline: none;
    color: #fff;
    background: #65bda0;
    width: auto;
    font-size: 16px;
    height: 40px;
    .iconfont {
      margin: 0 2px;
      color: #fff;
      display: none;
      font-size: 16px;
      height: 40px;
    }
  }
  .btn2:hover {
    opacity: 0.8;
  }
  .btn3 {
    border: 0;
    cursor: pointer;
    border-radius: 4px;
    padding: 0 24px;
    margin: 0 20px 0 0;
    outline: none;
    color: #fff;
    background: #2f6a38;
    width: auto;
    font-size: 16px;
    height: 40px;
    .iconfont {
      margin: 0 2px;
      color: #fff;
      display: none;
      font-size: 16px;
      height: 40px;
    }
  }
  .btn3:hover {
    opacity: 0.8;
  }
  .btn4 {
    border: 0;
    cursor: pointer;
    border-radius: 4px;
    padding: 0 24px;
    margin: 0 20px 0 0;
    outline: none;
    color: #7a6a5a;
    background: #e9cfbb;
    width: auto;
    font-size: 16px;
    min-width: 110px;
    height: 40px;
    .iconfont {
      margin: 0 2px;
      color: #fff;
      display: none;
      font-size: 16px;
      height: 40px;
    }
  }
  .btn4:hover {
    opacity: 0.8;
  }
  .btn5 {
    border: 0;
    cursor: pointer;
    border-radius: 4px;
    padding: 0 24px;
    margin: 0 20px 0 0;
    outline: none;
    color: #fff;
    background: #f5bda0;
    width: auto;
    font-size: 16px;
    min-width: 110px;
    height: 40px;
    .iconfont {
      margin: 0 2px;
      color: #fff;
      display: none;
      font-size: 16px;
      height: 40px;
    }
  }
  .btn5:hover {
    opacity: 0.8;
  }
}
.add-update-preview .el-form-item.btn /deep/ .el-form-item__label {
  padding: 0 10px 0 0;
  color: #666;
  white-space: nowrap;
  font-weight: 500;
  width: 180px;
  font-size: 16px;
  line-height: 40px;
  text-align: right;
}

.add-update-preview .el-form-item.btn /deep/ .el-form-item__content {
  margin: 0 0 0 80px;
  display: flex;
  align-items: center;
}
</style>
